import { DataHeader, DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutServiceTransitTimeMaster extends Layout {
    dataheaderServiceTransitTime: DataHeader;
    panelServiceTransitTime: Panel;
    sourceServiceTransitTime: DataSource;
    switchSwitchIncludeSaturday: Switch;
    switchSwitchIncludeSunday: Switch;
    textboxCalcTypeCode: Textbox;
    textboxEffectiveTimestamp: Textbox;
    textboxExpireTimestamp: Textbox;
    textboxPayeeId: Textbox;
    textboxPriority: Textbox;
    textboxServiceTypeCode: Textbox;
}
